import { RootState } from '@spa/lib/store/RootState';
import { StateWishlist } from '@spa/lib/store/wishlists/WishlistsState';

const selectWishlistTotalQuantityCount = ({ wishlists: { wishlists } }: RootState): number => {
  let totalQuantity: number = 0;

  wishlists.forEach((wishlist: StateWishlist) => (totalQuantity += wishlist.items.length));

  return Math.min(totalQuantity, 999);
};

export default selectWishlistTotalQuantityCount;
